import { useLocale, useTranslations } from 'next-intl'
import { Locale } from '@/setup/locales'
import { ExternalDeploymentUrl } from '@/setup/urls/external-deployment-urls'

export const TopPageBanner = () => {
    const locale = useLocale()

    const t = useTranslations()

    const shop = {
        linkParams: {
            externalUrl: ExternalDeploymentUrl.SHOP[locale as Locale],
            target: '_blank',
        },
        label: t('topBanner.message'),
    }

    return (
        <div className="w-full h-10 bg-black text-white flex items-center justify-center text-center">
            <a href={shop.linkParams.externalUrl} target={shop.linkParams.target} rel="noreferrer">
                {shop.label}
            </a>
        </div>
    )
}
